import React from 'react';
import './SectionCard.css';
import blockIcon from '../assets/icons/block.svg';

const SectionCard = ({ 
  section, 
  onClick, 
  className = '',
  isChat = false
}) => {
  const hasImage = section.image && section.image !== null && section.image !== '';
  const isBlockedChat = isChat && !section.external_link;
  const textColor = isBlockedChat && !section.text_color 
    ? 'var(--color-white)' 
    : (section.text_color || 'var(--color-text-dark)');
  
  return (
    <div 
      className={`section-card ${className}`}
      onClick={onClick}
    >
      <div className="section-background">
        <img 
          src={hasImage ? section.image : "/assets/images/section.png"}
          alt={section.title}
          className="section-image section-image-loaded high-quality-image"
          loading="lazy"
          decoding="async"
          onLoad={(e) => {
            // Плавно показываем изображение после загрузки
            if (e.target) {
              requestAnimationFrame(() => {
                e.target.style.opacity = '1';
              });
            }
          }}
          onError={(e) => {
            // Fallback при ошибке загрузки изображения
            console.warn('Failed to load image:', section.image);
            if (e.target) {
              e.target.style.display = 'none';
            }
          }}
        />
        <div className="section-overlay">
          <div className="section-content">
            <h3 
              className="section-title"
              style={{ 
                color: textColor + ' !important',
                '--custom-text-color': textColor
              }}
            >
              {section.title}
            </h3>
            {isChat && section.description && (
              <p 
                className="section-description"
                style={{ 
                  color: textColor + ' !important',
                  '--custom-text-color': textColor
                }}
              >
                {section.description}
              </p>
            )}
          </div>
        </div>

        {/* Черный слой и иконка замка для чатов без ссылок */}
        {isChat && !section.external_link && (
          <>
            <div className="section-overlay-dark"></div>
            <div className="section-lock-icon-container">
              <img 
                src={blockIcon} 
                alt="Заблокировано" 
                className="section-lock-icon"
                loading="lazy"
                decoding="async"
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SectionCard; 